/**
 * Loja escolhida em cada canal (quando há mais de uma conexão no mesmo canal, ex.: duas lojas Shopee).
 * Fica lembrada neste navegador e vale para todas as telas do canal.
 */
import { useSyncExternalStore } from 'react';

const KEY = (channel: string) => `berytus.account.${channel}`;
const listeners = new Set<() => void>();
const memory = new Map<string, string | null>();

function read(channel: string): string | null {
  if (memory.has(channel)) return memory.get(channel)!;
  let v: string | null = null;
  try { v = localStorage.getItem(KEY(channel)); } catch { /* sem armazenamento */ }
  memory.set(channel, v);
  return v;
}

export function selectAccount(channel: string, id: string) {
  memory.set(channel, id);
  try { localStorage.setItem(KEY(channel), id); } catch { /* sem armazenamento */ }
  for (const l of listeners) l();
}

export function useSelectedAccountId(channel: string | null): string | null {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
    () => (channel ? read(channel) : null),
  );
}

/** A conta escolhida entre as do canal (ou a primeira ativa). */
export function pickAccount<T extends { id: string; status: string }>(accounts: T[] | undefined, selected: string | null): T | null {
  const live = (accounts ?? []).filter((a) => a.status !== 'revoked');
  return live.find((a) => a.id === selected) ?? live.find((a) => a.status === 'active') ?? live[0] ?? null;
}
